import {baseUrl} from '.'

export const getLink = (fileId) => {
	// if (process.env.NODE_ENV !== 'production') {
	// 	return 'http://localhost:8080/download/?guid=' + guid
	// }
	// return '/download/?guid=' + guid
	return baseUrl() + "rest-service/file/" + fileId
};
